import { IContractCancellationsRepository } from 'modules/customer/domain/repositories';
import {
  ContractCancellationCommunication,
  ContractCancellationTracking,
  IVectisContractCancellationCommunication,
  IVectisContractCancellationTracking,
} from 'modules/customer/infra/adapters';
import IHTTPProvider from 'shared/domain/providers/IHTTPProvider';

export default class VectisContractCancellationsRepository
  implements IContractCancellationsRepository
{
  constructor(private httpProvider: IHTTPProvider) {}

  public findOpen: IContractCancellationsRepository['findOpen'] = async () => {
    const response = await this.httpProvider.get<
      IVectisContractCancellationTracking | ''
    >('/area-cliente/cancelamento-contrato/acompanhamento');

    return ContractCancellationTracking.fromResponse(response);
  };

  public findCommunications: IContractCancellationsRepository['findCommunications'] =
    async ({ cancellationId }) => {
      const response = await this.httpProvider.get<
        IVectisContractCancellationCommunication[] | ''
      >(`/area-cliente/cancelamento-contrato/${cancellationId}/comunicacoes`);

      if (!Array.isArray(response)) return [];

      return response.map(
        communication => new ContractCancellationCommunication(communication),
      );
    };

  public requestNewLink: IContractCancellationsRepository['requestNewLink'] =
    async ({ cancellationId }) => {
      await this.httpProvider.post(
        `/area-cliente/cancelamento-contrato/${cancellationId}/solicitar-novo-link`,
      );
    };
}
